import React from 'react';
import tw from 'twin.macro';

const TextAreaInput = tw.textarea`w-full dark:text-darkText p-2 border border-gray-100 dark:bg-darkSecondary border border-gray-200 dark:border-gray-600 focus:outline-none  focus:border-gray-300  dark:focus:border-gray-300 rounded-md dark:caret-darkText`;

export default TextAreaInput;
